/**
 * Internal dependencies
 */
import vd from "lib/vd";
import receiveDashboardLayouts from "./receive-dashboard-layouts";
import resetDashboardLayout from "./reset-dashboard-layout";
import * as actions from "state/action-types";

export default (layoutId, layout) => (dispatch) => {
  const isNew = !layoutId;

  if (isNew) {
    return vd
      .layout()
      .add(layout)
      .then((layout) => {
        dispatch(receiveDashboardLayouts([layout]));
        dispatch({
          type: actions.SAVE_DASHBOARD_LAYOUT_SUCCESS,
          payload: { layout, isNew },
        });
      });
  }

  return vd
    .layout(layoutId)
    .update(layout)
    .then((response) => {
      dispatch(receiveDashboardLayouts([response]));
      dispatch({
        type: actions.SAVE_DASHBOARD_LAYOUT_SUCCESS,
        payload: { layout: response, isNew },
      });
      dispatch(resetDashboardLayout(layoutId));
    });
};
